/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import ReportLayout from '../../components/Report/NewLayout/ReportLayout';

function Report() {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const period = urlParams.get('period') ?? 'monthly';

	return (
		<>
			<Container maxW="container.xl" mt="16px" mb="16px">
				<BreadcrumbComponent
					list={[
						{
							name: 'Insurance Institute Report',
							path: '/company-submission-report',
						},
						{
							name: period,
							path: '/company-submission-report?period=' + period,
						},
					]}
				/>
				<Box pb="32px" w="100%" mt="5">
					<ReportLayout period={period} />
				</Box>
			</Container>
		</>
	);
}

export default Report;
